package ui.resource.editor

import androidx.compose.runtime.*
import api.*
import common.frontend.api.*
import io.*
import kotlinx.coroutines.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.compose.navigation.viewmodel.*
import tk.mallumo.log.*
import tk.mallumo.utils.*
import tools.*
import ui.*

@VM
class VisualEditorVM : NavigationViewModel() {

    private lateinit var scopeUi: VisualEditorScope

    var state by mutableDataState<VisualEditorScope.Wrapper>()
        private set

    sealed interface Action {
        data object Generate : Action

        companion object {

            @Composable
            fun rememberAction(vm: VisualEditorVM): (Action) -> Unit {
                return remember {
                    { act ->
                        when (act) {
                            Generate -> vm.generate()
                        }
                    }
                }
            }
        }
    }

    private fun generate() {
        scope.launch {
            state.entry?.also { wrapper ->
                with(scopeUi) {
                    runCatching {
                        Repository.api.resource.transform(
                            companyId = args.companyId,
                            resourceId = args.resourceId,
                            props = wrapper.visualProperties
                        )
                    }.onSuccess {
                        nav.up(args.upStack)
                        snackBarStateGlobal.showSnackbar(
                            message = Res.string.visual_editor_confirm_result_success.await(),
                            withDismissAction = true
                        )
                    }.onFailure {
                        logINFO(it)
                        snackBarStateGlobal.showSnackbar(
                            message = Res.string.visual_editor_confirm_result_fail.await(),
                            withDismissAction = true
                        )
                    }
                }
            }
        }
    }


    fun init(scopeUi: VisualEditorScope) {
        this.scopeUi = scopeUi

        if (state !is DataState.Result) {
            state = DataState.Loading()
        }
        scope.launch {
            runCatching {
                val res = Repository.api.resource.single(scopeUi.args.companyId, scopeUi.args.resourceId)

                val primaryTitlePart = Res.string.visual_editor_title.await(ResourceType[res.type].labelRes.await().lowercase())
                val secondaryTitlePart = "(${scopeUi.args.resourceId})"
                val title = primaryTitlePart to secondaryTitlePart

                state = DataState.Result(
                    VisualEditorScope.Wrapper(
                        canUserDeleteResource = scopeUi.login.canResourceDelete(scopeUi.args.companyId),
                        containsReferences = res.usage.isNotEmpty(),
                        title = title,
                        data = res
                    )
                )
            }.onFailure {
                it.printStackTrace()
                state = DataState.Error(Res.string.err_connection_interrupted.await())
            }
        }
    }

    override fun onRelease() {
        state = DataState.Idle()
    }

}
